/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCapture = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 11h10v2H7zM4 4h5V2H2v7h2zm3 3h10v2H7zm-3 8H2v7h7v-2H4zM15 2v2h5v5h2V2zM7 15h6v2H7zm13 5h-5v2h7v-7h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCapture as Capture };
